module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tocchaptitle"
  }, [_c('a', {
    attrs: {
      "id": "contents"
    }
  }), _c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/05introduction#intro"
    }
  }, [_c('b', [_c('i', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-01"
    }
  }, [_vm._v("Rods (Skyfish)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-02"
    }
  }, [_vm._v("Mongolian Death Worms")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-04"
    }
  }, [_vm._v("Ahool and Other Giant Bats")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-06"
    }
  }, [_vm._v("Loogaroo Vampires of the West Indies")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-08"
    }
  }, [_vm._v("Bunyips (Water Horses)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-10"
    }
  }, [_vm._v("Kentucky Goblins")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-11"
    }
  }, [_vm._v("Tommyknockers of California")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-13"
    }
  }, [_vm._v("Enfield Horror (Giant Kangaroos)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-15"
    }
  }, [_vm._v("Frogmen of Loveland")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-17"
    }
  }, [_vm._v("Gray Man of Ben MacDhui")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-19"
    }
  }, [_vm._v("Lusca and Other Giant Octopuses")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-21"
    }
  }, [_vm._v("Flying Man of Falls City, Nebraska, and Other Flying Humanoids")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-23"
    }
  }, [_vm._v("The Awful")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-24"
    }
  }, [_vm._v("Beast of Busco (Giant Turtle)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-26"
    }
  }, [_vm._v("Giant Rabbits of England")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-28"
    }
  }, [_vm._v("Thunderbirds ("), _c('i', [_vm._v("Piasa")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-30"
    }
  }, [_vm._v("Jake and Other Alligator Men")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-32"
    }
  }, [_vm._v("Beast of Bray Road and Other Contemporary Werewolves")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-34"
    }
  }, [_vm._v("Goatman")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-35"
    }
  }, [_vm._v("Giant Catfish")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-36"
    }
  }, [_vm._v("Moas (Giant Flightless Birds)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-38"
    }
  }, [_vm._v("Shadow People")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-39"
    }
  }, [_vm._v("Black Dogs")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-40"
    }
  }, [_vm._v("Kappa (Japanese River Imps)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-42"
    }
  }, [_c('i', [_vm._v("Encantados")]), _vm._v(" (Dolphin-Men of Brazil)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-44"
    }
  }, [_c('i', [_vm._v("Clurichauns")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-45"
    }
  }, [_vm._v("Giant Spiders")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-46"
    }
  }, [_vm._v("Boston Lemur")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-47"
    }
  }, [_vm._v("Dragons")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-48"
    }
  }, [_vm._v("Spring Heeled Jack")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-50"
    }
  }, [_vm._v("Beast of Bladenboro, North Carolina")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-52"
    }
  }, [_vm._v("Ohio Grassman")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-53"
    }
  }, [_vm._v("Lizard Man of Scape Ore, South Carolina")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-55"
    }
  }, [_vm._v("Lobo (Wolf) Girl of Texas")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-57"
    }
  }, [_vm._v("Giant Rats of New York City")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-59"
    }
  }, [_vm._v("Dover Demon")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-60"
    }
  }, [_vm._v("Mothman of West Virginia")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-62"
    }
  }, [_vm._v("New Jersey Devil")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-63"
    }
  }, [_c('i', [_vm._v("Chupacabra")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "0.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/06chapter01#c01-64"
    }
  }, [_vm._v("A Tale of MoMo (Missouri Monster)")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "3pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07furtherreading#further"
    }
  }, [_c('b', [_c('i', [_vm._v("Further Reading")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d442fbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04-content.vue
// module id = 69
// module chunks = 0